import { render, staticRenderFns } from "./FakeInput.vue?vue&type=template&id=e09858fe"
import script from "./FakeInput.vue?vue&type=script&lang=ts"
export * from "./FakeInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports